<template>
  <div class="layout reg_wrap">
      <div class="avatar">
          <img :src="userForm.avatarUrl" @click="setImg" v-load="'oAvatar'">
        <p>点击更换头像</p>
      </div>
      <van-form @submit="onSubmit" class="reg_user_form" scroll-to-error error-message-align="right" input-align="right">
        <van-field
          v-model="userForm.nickName"
          name="nickName"
          label="昵称"
          maxlength="7"
          :error="!userForm.nickName"

          placeholder="请输入昵称"
          :rules="[{ required: true, message: '请填写昵称' }]"  
        />
        <!-- :rules="[{required:true,validator:validatorPhone, message: '请输入正确手机号' }]" -->
        <van-field
          v-model="userForm.phone"
          name="phone"
          label="手机"
          placeholder="请输入手机号"
          readonly
        >
        <template #button>
          <span @click="editPhone" class="text" >更改</span>
         </template>
        </van-field>
        <!-- <van-field
          v-model="userForm.code"
          name="code"
          label="验证码"
          :rules="[{required:true,message:'请输入验证码'}]"
        >
         <template #button>
          <span class="send_code" v-if="timer" style="color:#999;">{{ count || 0}}s</span>
          <span @click="send" class="send_code"   v-else>获取验证码</span>
         </template>
        </van-field> -->
        <van-field
          readonly
          clickable
          is-link
          name="title"
          :value="userForm.title"
          label="称谓"
          placeholder="请选择"
          @click="showTitle= true"
        />
        <van-popup v-model="showTitle" position="bottom">
          <van-picker
            show-toolbar
            :columns="titleList"
            :default-index="oldTitle"
            @confirm="onTitle"
            @cancel="showTitle = false"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="birthday"
          is-link
          :value="userForm.birthday"
          label="出生年份"
          placeholder="请选择"
          @click="showDateBirth = true"
        />
        <van-popup v-model="showDateBirth" position="bottom">
          <van-datetime-picker
            v-model="dateVal"
            type="date"
            title="选择出生日期"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onDateBirth"
            @cancel="showDateBirth = false"
          />
        </van-popup>
         <p>个人简介</p>
        <van-field
          class="input_brief"
          name="introduction"
          v-model="userForm.introduction"
          type="textarea"
          maxlength="200"
          show-word-limit
          input-align="left"
          placeholder="请输入"  
          @input="inputIntord"
        />

          <p class="more" @click="moreClick()" v-if="userInfo.userRole >1" style="color: #f85b0f;padding-bottom: 2rem">编辑认证资料</p>
          <p class="more" @click="moreClick()" v-else style="color: #f85b0f;padding-bottom: 2rem">认证成为专业买家，解锁更多权限</p>
          <van-button class="sumbit_btn" color="#f85b0f" block type="info" native-type="submit" >保存</van-button>
      </van-form>


      <van-popup class="phone_pop" v-model="oldPhoneShow" :close-on-click-overlay="false">
        <p>原手机验证</p>
        <van-field v-model="userForm.phone" readonly  />
        <van-field
          type="digit"
          v-model="userForm.code"
          :rules="[{required:true}]"

        >
         <template #button >
          <span  v-if="timer" style="color:#999;">{{ count || 0}}s</span>
          <span @click="send" class="send_code"   v-else>获取验证码</span>
         </template>
        </van-field>
        <div class="phone_pop_button">
          <van-button type="default" block @click="userForm.code='';codeKey='';oldPhoneShow=false">取消</van-button>
          <van-button type="default" block :disabled="!userForm.code" @click="next">下一步</van-button>
        </div>
      </van-popup>
      <van-popup class="phone_pop" v-model="newPhoneShow" :close-on-click-overlay="false">
        <p>更换手机号</p>
        <van-field 
          type="digit"
          placeholder="请输入新手机号"
          v-model="newPhone" 
        >
        </van-field>
        <van-field
          type="digit"
          v-model="newCode"
          :rules="[{required:true}]"
        >
         <template #button >
          <span  v-if="newTimer" style="color:#999;">{{ newCount || 0}}s</span>
          <span @click="newSend" class="send_code"   v-else>获取验证码</span>
         </template>
        </van-field>
        <div class="phone_pop_button">
          <van-button type="default" block @click="newCodeKey='';newPhone='';newPhoneShow=false">取消</van-button>
          <van-button type="default" block :disabled="!validatorPhone(newPhone)||!newCode" @click="newSubmit">确定</van-button>
        </div>
      </van-popup>
  </div>
</template>

<script>
import moment from "moment"
import { mapActions, mapGetters, mapMutations } from "vuex";
// import { delete } from 'vue/types/umd';
const delay = (function () {
 let timer = 0
 return function (callback, ms) {
  clearTimeout(timer)
  timer = setTimeout(callback, ms)
 }
})()
export default {
  name: "registry",
  components:{
  },
  data() {
    return {
      userForm:{
        avatarUrl:'', //头像
        nickName:'',  //昵称
        phone:'',     //手机
        title:'',       //称谓
        birthday:'', //出生日期
        introduction:'',      //个人简介
        code:'',      //验证码
      },
      codeKey:'',     //验证码key
      newCodeKey:'',   //新验证码key
      newPhoneShow:false,//新手机号认证弹框
      newPhone:'',  //新手机号
      newCode:'', //新验证码
      newTimer:null,  //新验证码相关
      newCount:0,     //新验证码相关
      oldPhoneShow:false, //原手机认证弹框
      showTitle:false,  //称谓选择框
      oldTitle:0,
      showDateBirth:false,  //出生日期选择框
      maxDate:new Date(),
      dateVal:new Date(),
      minDate:new Date(1940, 0, 1),
      titleList:['先生','小姐','女士'],
      count:0,  //验证码相关
      timer:null,  //验证码相关,
      inputTimer:null //截流相关
    } 
  },
  mounted(){
    if(this.userForm.birthday){
      let Y=moment(this.userForm.birthday).format("YYYY");
      let M=moment(this.userForm.birthday).format("MM");
      let D=moment(this.userForm.birthday).format("DD");
      this.dateVal=new Date(Y,M-1,D)
    }
  },
  computed: {
    ...mapGetters({
      exhibitionId:'getExhibitionId',
      userId: 'getUserId',
      userInfo: 'getUserInfo',    //观众信息
      inMemberId:'getInMemberId'
    }),
  },
  created() {
    this.getUser();
    this.userForm={
      avatarUrl:this.userInfo.avatarUrl?this.userInfo.avatarUrl:'',
      nickName:this.userInfo.nickName?this.userInfo.nickName:'',
      phone:this.userInfo.phone?this.userInfo.phone:'',
      title:this.userInfo.title?this.userInfo.title:'',
      birthday:this.userInfo.birthday?this.userInfo.birthday:'',
      introduction:this.userInfo.introduction?this.userInfo.introduction:'',
    }
    if(this.userInfo.title){
      this.oldTitle=this.titleList.indexOf(this.userInfo.title);
    }
  },
  //销毁前重新获取用户信息
  beforeDestroy(){
    // this.getUser()
  },
  methods:{
    ...mapActions({
      sendCode: "login/sendCode",
      validateCode: "login/validateCode",
      editUser:"login/editUser",
      getUser: "login/getUser",
      wxUpLoadImg:'upload/wxUpLoadImg',
      registryUser:'login/registryUser',
      memberUpdate:'login/memberUpdate',
      modifyUser:'login/modifyUser'
    }),
    //手机号校验
    validatorPhone(val){
      return /^1[3456789]\d{9}$/.test(val);
    },
    //个人简介输入 静默提交
    inputIntord(val){
      // delay(()=>{
      //   this.onSubmit('introduction',val)
      //   .then((data)=>{
      //     if(data){
      //       this.userForm.introduction=val;
      //       this.showTitle=false;
      //     }
      //     else{
      //       this.$toast.fail({
      //         message:'修改失败',
      //         closeOnClick :true
      //       });
      //     }
      //   });
      // },1500)
    },
    //节流函数
    debounce(val,delay=1000){
      let timer = 0;
      return function (callback, ms) {
        clearTimeout(timer)
        timer = setTimeout(callback, ms)
      }
    },
    //昵称校验 成功后直接修改
    inputNickname(val){
      //修改昵称
      // delay(()=>{
      //   if(val){
      //     this.onSubmit('nickName',val)
      //     .then((data)=>{
      //       if(data){
      //         this.userForm.nickName=val;
      //         this.showTitle=false;
      //       }
      //       else{
      //         this.$toast.fail({
      //           message:'修改失败',
      //           closeOnClick :true
      //         });
      //       }
      //     });
      //
      //   }
      //   else{
      //     return
      //
      //   }
      // },1500)
      // this.debounce(val);
    },
    //更改手机号
    editPhone(){
      this.oldPhoneShow=true;
    },
    //原手机认证->下一步 校验验证码，返回之后打开更换手机号弹框
    async next(){
      let res = await this.validateCode({
        key:this.codeKey,
        code: this.userForm.code
      });
      if(res){
        console.log('验证成功')
        this.oldPhoneShow=false;
        this.newPhoneShow=true;
      }else{
        this.$toast.fail({
            message:'验证码有误',
            closeOnClick :true
        });
      }
    },
    //新手机号确认发送  
    async newSubmit(){
      let res = await this.validateCode({
        key: this.newCodeKey,
        code: this.newCode
      });
      if(res){
          this.userForm.phone=this.newPhone;
          this.newPhoneShow=false;
          this.userForm.code = ''
          this.$toast.success({
              message:'更换成功',
              closeOnClick :true
          });
        //更换手机号
        //   if(data){
        //       this.userForm.phone=this.newPhone;
        //       this.newPhoneShow=false;
        //       this.userForm.code = ''
        //       this.$toast.success({
        //           message:'更换成功',
        //           closeOnClick :true
        //       });
        //   }
        //   else{
        //       this.userForm.code = ''
        //       this.$toast.fail({
        //           message:'更换失败',
        //           closeOnClick :true
        //       });
        //   }
      }else{
        this.$toast.fail({
            message:'验证码有误',
            closeOnClick :true
        });
      }
    },
    //发送新验证码
    async newSend(){
      if(!this.validatorPhone(this.newPhone))
      {
        this.$toast.fail({
          message:'手机号有误',
          closeOnClick :true
        });
        return
      }
      this.$toast.loading({
        message: '发送中...',
        forbidClick: true,
      });
      
      let res = await this.sendCode({
        PhoneNumber: this.newPhone
      });
      if (res.data && res.result) {
        this.newCodeKey=res.data.key;
        this.$toast.success('已发送');
        this.newDownTime();
      } else {
        this.$toast.fail("发送失败！");
      }
    },
    //发送原手机验证码
    async send(){
      if(!this.validatorPhone(this.userForm.phone))
      {
        return 
      }
      this.$toast.loading({
        message: '发送中...',
        forbidClick: true,
      });
      
      let res = await this.sendCode({
        PhoneNumber: this.userForm.phone
      });
      if (res && res.result) {
        this.codeKey=res.data.key;
        this.$toast.success('已发送');
        this.downTime();
      } else {
        this.$toast.fail("发送失败！");
      }
    },
    //新手机号倒计时
    newDownTime() {
      const newTIME_COUNT = 60;
      if (!this.newTimer) {
        this.newCount = newTIME_COUNT;
        const newTimer = setInterval(() => {
          let count = this.newCount;
          if (count > 0 && count <= newTIME_COUNT) {
            count--;
            this.newCount = count;
          } else {
            clearInterval(this.newTimer);
            this.newTimer = null;
          }
        }, 1000);
        this.newTimer = newTimer;
      }
    },
    //倒计时
    downTime() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        const timer = setInterval(() => {
          let count = this.count;
          if (count > 0 && count <= TIME_COUNT) {
            count--;
            this.count = count;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        this.timer = timer;
      }
    },
    //称谓选择
    onTitle(val){
      // this.userForm.title=val;
      // this.showTitle=false;
        this.userForm.title=val;
        this.showTitle=false;
      // this.onSubmit('title',val)
      // .then((data)=>{
      //   if(data){
      //
      //   }
      //   else{
      //     this.$toast.fail({
      //       message:'修改失败',
      //       closeOnClick :true
      //     });
      //   }
      // });

    },
    //出生日期选择
    onDateBirth(date){
      let newDate=moment(date).format("YYYY-MM-DD");
        this.userForm.birthday=newDate;
        this.showDateBirth=false;
      // this.userForm.birthday=;
      // this.onSubmit('birthday',newDate)
      // .then((data)=>{
      //   if(data){
      //
      //   }
      //   else{
      //     this.$toast.fail({
      //       message:'修改失败',
      //       closeOnClick :true
      //     });
      //   }
      // });
    },
    //更换头像
    async setImg() {  // 设置云名片图片
      const that = this; 
      const callBack = (data) => { 
        console.log('coverImg编辑个人资料', data);
      };
      const img = await this.wxUpLoadImg(callBack); 
      console.log('编辑头像上传的图片：', img); 
      if(img){
        this.userForm.avatarUrl = img;
        this.onSubmit('avatarUrl',this.userForm.avatarUrl);
      }else{
        this.$toast.fail({
          message:'上传头像失败',
          closeOnClick :true
        });
      }
    },
    //提交
    async onSubmit(value){
        if((/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.userForm.introduction))){
            this.$toast.fail('请勿输入手机号')
            return;
        }
        value.avatarUrl = this.userForm.avatarUrl
        value.inMemberId = this.inMemberId;
        delete value.phone;
        console.log(value)
        let res= await this.modifyUser(value);
        if(res && res.result){
            this.$toast.success({
                message:'修改成功',
            })
            this.getUser()
            return true
        }else {
            this.$toast.fail({
                message: '修改失败',
                closeOnClick: true
            });
            return false
        }
        // if (this.userInfo.userRole<2){
        //
        // }
        // //专业买家身份
        // else if(this.userInfo.userRole==2){
        //     value.name = this.userInfo.name
        //     value.jobTitle = this.userInfo.jobTitle
        //     value.company = this.userInfo.company
        //     value.department= this.userInfo.department
        //     value.country= this.userInfo.country
        //     value.province= this.userInfo.province
        //     value.city= this.userInfo.city
        //     value.county = this.userInfo.county
        //     value.address = this.userInfo.address
        //     value.category = this.userInfo.category
        //     value.businessCard = this.userInfo.businessCard
        //     let res =await this.memberUpdate(value)
        //     if(res && res.result){
        //         this.$toast.success({
        //             message:'修改成功',
        //         })
        //         this.getUser()
        //         return true
        //     }else{
        //         this.$toast.fail({
        //             message:'修改失败',
        //             closeOnClick :true
        //         });
        //         return false
        //     }
        // }

    },
    //更多点击    普通用户：跳通用户：跳转认证专业买家页面 专业买家：跳转编辑认证资料页面
    moreClick(){
        console.log(this.userInfo.auditState,this.userInfo.userRole)
        if (this.userInfo.auditState==0){
            this.$toast.fail({
                message:'认证资料正在审核中，请耐心等待...',
            })
        }
        else {
            this.$router.push('/editAuerbach');
        }

    },
    
  }
};
</script>
<style lang="scss">
  
</style>
<style lang="scss" scoped>
    .sumbit_btn{
        font-size: 0.36rem;
        height: 0.98rem;
        line-height: 0.98rem;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0;
        span{
            font-size: 0.36rem;
        }
    }
.reg_wrap{
    background: #131825;
    padding:0 0.24rem;

    .avatar{
      padding-top: 0.5rem;
      padding-bottom: 0.39rem;
      border-bottom: 1px solid #1d2435;
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        height: 1.4rem;
        width: 1.4rem;
        border: 2px solid #fff;
        border-radius: 50%;
        // object-fit: cover;
        .van-uploader__wrapper{
          height: 1.4rem;
          width: 1.4rem;
          
        } 
      }
      
      p{
        color: #fff;
        line-height: 1;
        margin-top: 0.2rem ;
      }
    }
    .reg_user_form{
      &::v-deep .van-cell{
        background: transparent;
        color: #fff;
        padding:0.3rem 0;
        border-bottom: 1px solid #1d2435;
        font-size: 0.3rem;
        &.input_brief{
          border-bottom:none;
          padding:0.2rem 0.2rem 0.1rem;
          background: #1d2435;
          border-radius: 0.03rem;

          .van-cell__value{ 
            .van-field__body{
              
              .van-field__control{
                font-size: 0.24rem;
                line-height: 0.28rem;
              }
            }
            .van-field__word-limit{
                font-size: 0.24rem;
              }
          }
        }
        &::after{
          display: none;
        }
        .van-cell__value{ 
          .van-field__body{
            .van-field__control{
              font-size: 0.3rem;
              color: #bfbfbf;
            }
            .van-field__button{
                padding-left: 0.28rem;
              }
            .text{
              font-size: 0.3rem;
              color: #f85b0f;
              vertical-align: middle;
            }
          }
        }
        .van-cell__title{
          span{
            font-size: 0.3rem;
          }
        }
      }
      >p{
        font-size: 0.3rem;
        color: #fff;
        line-height: 1;
        padding: 0.35rem 0 0.2rem;

      }
      /*.sumbit_btn{*/
      /*  font-size: 0.36rem;*/
      /*  height: 0.98rem;*/
      /*  line-height: 0.98rem;*/
      /*  position: fixed;*/
      /*  bottom: 0;*/
      /*  left: 0;*/
      /*  right: 0;*/
      /*  border-radius: 0;*/
      /*  span{*/
      /*    font-size: 0.36rem;*/
      /*  }*/
      /*}*/
    }
    .phone_pop{
      transform: translate(-50%,-50%);
      height: 4.58rem;
      width: 5.6rem;
      border-radius: 0.06rem;
      color: #333;
      padding: 0.6rem 0.35rem 0;
      overflow: hidden;
      >p{
        font-size: 0.36rem;
        line-height: 1;
        text-align: center;
        margin-bottom:0.5rem;
      }
      &::v-deep .van-cell{
        padding: 0 0.2rem;
          padding-top: 0.15rem;
        border: 1px solid #e6e6e6;
        border-radius: 1px;
        height: 0.7rem;
        line-height: 0.4rem;
        &:nth-child(2){
          margin-bottom: 0.2rem;
        }
        .van-field__control{
          font-size: 0.3rem;
          &[readonly=readonly]{
            color: #bfbfbf;
          }
        }
        .van-field__button{
          span{
            font-size: 0.26rem;
          }
          .send_code{
            color:#1890ff ;
          }
        }
        
      }
      .phone_pop_button{
          height: 1.01rem;
          width: 100%;
          display: flex;
          position: absolute;
          border-top: 1px solid #d2d3d5;
          left: 0;
          right: 0;
          bottom: 0;
          &::v-deep .van-button{
            line-height: 1rem;
            height: 1rem;
            border: none;
            border-radius: 0;
            color: #333;
            &:last-child{
              color:#fe5502 ;
            }
            &[disabled=disabled]{
              color: #bfbfbf;
            }
            .van-button__text{
              font-size: 0.36rem;
            }
            &:first-child{
              border-right: 1px solid #d2d3d5;
            }
            
          }
      }
    }
    .more{
      text-align: center;
      font-size: 0.3rem;
      color: #f85b0f;

    }

}
</style>
